import React, { useState } from 'react'
import AgentDetailsSection from './AgentDetailsSection'
import ApplicationDetails from './ApplicationDetails'
import DocumentSummary from '../IntakeTraige/DocumentSummary'
import AppetiteSummaryTabs from './AppetiteSummaryTabs'
import MenuList from '../MenuList'

function AppetiteSummary () {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <div className='flex flex-col items-start rounded-none application-details'>
      <div className='flex items-center space-x-2'>
        <MenuList isOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <h1 className='font-semibold py-2 text-2xl text-orange-600'>
          Application Details
        </h1>
      </div>
      <AgentDetailsSection />
      <div className='flex w-full'>
        {/* ApplicationDetails Component - occupies 50% of the width */}
        <div className='w-1/2 py-4'>
          <ApplicationDetails />
        </div>

        {/* DocumentSummaryTabs Component - occupies 50% of the width */}
        <div className='w-1/2 px-4'>
          <DocumentSummary />
        </div>
      </div>
      <AppetiteSummaryTabs />
      <div class="flex mt-6 justify-end w-full">
        <button value="Approve" class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Submit</button>
      </div>
    </div>
  )
}

export default AppetiteSummary
